export default "__VITE_ASSET__BWrg62gK__"